import { AppBar, styled, useTheme } from "@mui/material";
import React from "react";

export const ThemedAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: "4px 4px 20px 3px rgb(0 0 0 / 7%)",
}));

export type SideBarItemProps = {
  children: React.ReactNode;
};
export const SideBarItemWrapper = ({
  children,
}: SideBarItemProps): React.ReactElement => {
  const theme = useTheme();

  return (
    <div
      style={{
        paddingLeft: theme.spacing(2),
      }}
    >
      {children}
    </div>
  );
};
